import React from "react";
import { Form, Input } from "semantic-ui-react";

const SearchInput = ({ name, value, onChange, disabled }) => {
  return (
    <Form.Field width={5}>
      <label>Search:</label>
      <Input
        icon="search"
        name={name ?? "search"}
        value={value}
        onChange={onChange}
        disabled={disabled}
      />
    </Form.Field>
  );
};

export default SearchInput;
